import { Observable } from 'rxjs/Observable';
import { addFavorite } from '../utils/api';
import { FavoriteApi } from '../parsers';
import {
  ADD_FAVORITE_REQUEST,
  addFavoriteSucceeded,
  addFavoriteFailed,
} from '../redux/favorites';

import type { ActionObs, Store, Obs } from '../types';

export default function addFavoriteEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(ADD_FAVORITE_REQUEST)
    .switchMap(({ payload: { packageId } }) => {
      return addFavorite({ packageId })
        .map(resp => FavoriteApi.parse(resp))
        .map(({ favorite }) => addFavoriteSucceeded(favorite))
        .catch(err =>
          Observable.of(addFavoriteFailed(`${packageId} ${err.message}`)),
        );
    });
}
